/**
 * c-faq-list.js
 *
 * よくある質問 アコーディオン開閉
 * 各 FAQ item は独立して開閉可能（複数同時開可）。
 *
 * 開閉アニメーション: 一定の px/s 速度で開閉 (content 高さに応じて duration 動的計算)
 *   - SPEED_PX_PER_SEC: 1 秒あたりの開閉ピクセル数
 *   - MIN/MAX_DURATION: 短すぎ/長すぎ防止のクランプ
 * footer アコーディオン (c-footer.liquid 内 JS) と同一仕様。
 */

(function () {
  'use strict';

  var SPEED_PX_PER_SEC = 1500;
  var MIN_DURATION = 0.18;
  var MAX_DURATION = 0.45;

  function calcDuration(heightPx) {
    var d = heightPx / SPEED_PX_PER_SEC;
    if (d < MIN_DURATION) return MIN_DURATION;
    if (d > MAX_DURATION) return MAX_DURATION;
    return d;
  }

  document.querySelectorAll('[data-c-faq-list]').forEach(function (root) {
    var items = root.querySelectorAll('[data-c-faq-item]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-c-faq-toggle]');
      var panel = item.querySelector('.c-faq-list__answer');
      if (!btn || !panel) return;

      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';

        if (expanded) {
          // 閉じる: 現在の高さを設定 → 次フレームで 0 へ
          var h = panel.scrollHeight;
          var d = calcDuration(h);
          panel.style.transitionDuration = d + 's';
          panel.style.maxHeight = h + 'px';
          // force reflow
          // eslint-disable-next-line no-unused-expressions
          panel.offsetHeight;
          panel.style.maxHeight = '0';
          btn.setAttribute('aria-expanded', 'false');
          item.classList.remove('is-open');
        } else {
          // 開く: scrollHeight 取得 → そこへ transition
          panel.style.maxHeight = 'none';
          var h2 = panel.scrollHeight;
          panel.style.maxHeight = '0';
          // force reflow before re-setting
          // eslint-disable-next-line no-unused-expressions
          panel.offsetHeight;
          var d2 = calcDuration(h2);
          panel.style.transitionDuration = d2 + 's';
          panel.style.maxHeight = h2 + 'px';
          btn.setAttribute('aria-expanded', 'true');
          item.classList.add('is-open');

          // 開ききった後 max-height: none に解除 (動的コンテンツで再 reflow 不要にする)
          var onEnd = function (e) {
            if (e.propertyName !== 'max-height') return;
            panel.style.maxHeight = 'none';
            panel.removeEventListener('transitionend', onEnd);
          };
          panel.addEventListener('transitionend', onEnd);
        }
      });
    });
  });
})();
